import React, { Component } from "react";
import { isSafari } from "../../../utils/userAgentProtection";

class Hero extends Component {
	state = {
		isSafari: false,
		showMobilePreview: false
	};

	componentDidMount() {
		// Detect Safari browser
		const safariDetected = isSafari();
		this.setState({ isSafari: safariDetected });

		if (this.props.itemId || this.props.restaurant) {
			console.log("trigger use app button");
			this.__useApp();
			setTimeout(() => {
				this.forceUpdate();
			}, 2000);
		}

		// For Safari and problematic browsers, show mobile preview directly
		if (safariDetected || this.props.isSafari) {
			this.setState({ showMobilePreview: true });
		}
	}

	__useApp = () => {
		if (this.refs.phoneView) {
			this.refs.phoneView.classList.remove("blured");
		}
		if (this.refs.phone) {
			this.refs.phone.classList.add("phone-use");
		}
		localStorage.setItem("useAppClicked", "true");
	};

	handleSafariFallback = () => {
		if (this.props.onSafariFallback) {
			this.props.onSafariFallback();
		}
	};

	handleOpenMobileApp = () => {
		// Open the mobile version in a new tab
		const mobileUrl = window.location.href.split('?')[0] + '?mobile=true';
		window.open(mobileUrl, '_blank');
	};

	// Create mobile preview component
	createMobilePreview = () => {
		return (
			<div className="mobile-preview">
				<div className="mobile-preview-header">
					<div className="mobile-status-bar">
						<span className="mobile-time">9:41</span>
						<div className="mobile-icons">
							<span className="mobile-signal">📶</span>
							<span className="mobile-wifi">📶</span>
							<span className="mobile-battery">🔋</span>
						</div>
					</div>
				</div>
				<div className="mobile-preview-content">
					<div className="mobile-app-content">
						<div className="mobile-logo">
							<img 
								src={`/assets/img/logos/${localStorage.getItem("storeLogo")}`} 
								alt="Logo"
								style={{ height: '40px' }}
							/>
						</div>
						<div className="mobile-text">
							<h3>BHOOMEE Mobile App</h3>
							<p>Fresh fruits and vegetables delivered from farmers to your doorstep.</p>
						</div>
						<button 
							className="btn btn-primary"
							onClick={this.handleOpenMobileApp}
							style={{ backgroundColor: localStorage.getItem("storeColor") }}
						>
							Open Mobile App
						</button>
					</div>
				</div>
			</div>
		);
	};

	renderMobileContent = () => {
		const { showMobilePreview } = this.state;
		
		if (showMobilePreview) {
			return this.createMobilePreview();
		}

		// Try iframe for non-Safari browsers
		return (
			<div className="iframe-wrapper">
				<iframe
					title="appIframe"
					src={window.location.href.split('?')[0] + '?mobile=true&iframe=true'}
					frameBorder="0"
					id="appIframe"
					onError={() => this.setState({ showMobilePreview: true })}
				/>
			</div>
		);
	};

	render() {
		return (
			<React.Fragment>
				<div className="container-fluid p-0 main-container-desktop">
					<div className="container">
						<div className="row">
							<div className="col-md-6">
								<div className="col-md-12 left-col">
									<img
										src={`/assets/img/logos/${localStorage.getItem("storeLogo")}`}
										alt={localStorage.getItem("storeName")}
										className="desktop-logo"
									/>
									<h1 className="desktop-title">{localStorage.getItem("desktopHeading")}</h1>
									<h3
										className="desktop-subtitle"
										dangerouslySetInnerHTML={{
											__html: localStorage.getItem("desktopSubHeading"),
										}}
									/>
									<div
										className="btn-unblur"
										onClick={this.__useApp}
										style={{
											backgroundColor: localStorage.getItem("storeColor"),
										}}
									>
										{localStorage.getItem("desktopUseAppButton")}
									</div>
								</div>
							</div>
							<div className="col-md-6 mt-50">
								<div
									className={`col-md-12 ${localStorage.getItem("useAppClicked") !== "true" &&
										"blured"}`}
									ref="phoneView"
								>
									<div
										className={`phone ${localStorage.getItem("useAppClicked") === "true" &&
											"phone-use"}`}
										ref="phone"
									>
										<div className="notch" />
										{this.renderMobileContent()}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default Hero;
